// @flow
import defaultState from '../defaultState';
import type {
  LoadGlobalSettingAction,
  LoadGlobalSettingsAction
} from '../actions/settings/settingsCreators';

type Action = LoadGlobalSettingAction | LoadGlobalSettingsAction;

const defaultSettings = defaultState.settings;

export default function settings(
  state: Object = defaultSettings,
  action: Action
) {
  switch (action.type) {
    case 'LOAD_GLOBAL_SETTINGS':
      return action.settings;
    case 'LOAD_GLOBAL_SETTING':
      return {
        ...state,
        [action.setting.name]: {
          ...action.setting
        }
      };
    case 'LOGOUT':
      return defaultSettings;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/settings.js